let sdkPromise;
const activated = {};

/**
 * @memberof module:asos-web-toggle-point-optimizely
 * @inner
 * @description Activates a feature with Optimizely. Includes an in-built cache of the SDK returned from the sdkInstanceProvider and a cache of already-enabled features; assumes singleton lifecycle within the host application.
 * @param {object} params parameters
 * @param {external:HostApplication.sdkInstanceProvider} params.sdkInstanceProvider SDK instance provider
 * @param {string} params.featureName name of the feature to activate
 * @param {Object<string, string>} [params.audience] audience used to make the decision for this feature; it must match here to report back appropriately
 * @example
 * activateFeature({
 *   sdkInstanceProvider,
 *   "test-feature",
 *   audience: {
 *     "app": "plp",
 *     "url": "https://www.asos.com/women/new-in/new-in-clothing/cat/?cid=2623"
 *   }
 * });
 */
const activateFeature = async ({
  sdkInstanceProvider,
  featureName,
  audience
}) => {
  if (!sdkPromise) {
    sdkPromise = (async () => {
      const sdk = await sdkInstanceProvider("features");
      await sdk.onReady();
      return sdk;
    })();
  }
  const sdk = await sdkPromise;

  if (!activated[featureName]) {
    sdk.getFeature(featureName, null, audience).isEnabled();
    activated[featureName] = true;
  }
};

export default activateFeature;
